import React, { useState, useEffect } from 'react';
import './NodeHierarchy.scss';
import { consumeAPIs } from '../../commonUtils/APIContext';

import { SplitPanelUtil } from '../../commonUtils/SplitPanelUtil';
import {
  HierarchyTable,
  Column,
  TreeNode
} from '../../commonUtils/HierarchyTable';
import { Input } from '@scuf/common';
import i18next from '../../../i18next';


interface INodeHierarchyProps {
  handleChange: (event: any, type: string) => void;
  selectedNode: any[];
  organisationHierarchy: TreeNode[];
  loading: boolean;
  onExpand(e: { originalEvent: Event; node: TreeNode }): void;
  onSelect: (event: any) => void;
  onUnselect: (event: any) => void;
}

export const NodeHierarchy = (props: INodeHierarchyProps) => {
  const [globalFilter, setGlobalFilter] = useState<string>('');
  const [totalRecords, setTotalRecords] = useState(0);

  useEffect(() => {
    let total = 0;
    for (let i = 0; i < props.organisationHierarchy.length; i++) {
      total += countTotalRecords(props.organisationHierarchy[i]) + 1;
    }
    setTotalRecords(total);
  }, [props.organisationHierarchy]);

  const countTotalRecords = (node: TreeNode): number => {
    if (node.children.length === 0) {
      return 0;
    }

    return (
      node.children.length +
      node.children
        .map(child => countTotalRecords(child))
        .reduce((a, b) => a + b)
    );
  };

  const getHeader = () => {
    return (
      <div className="hierarchy-view-header">
        <Input
          placeholder={i18next.t('searchFor')}
          onChange={e => setGlobalFilter(e)}
          search={true}
        />
        <span className="node-count">{totalRecords} {i18next.t('nodes')}</span>
      </div>
    );
  };

  return (
    <div className="hierarchy-view">
      <SplitPanelUtil>
        <SplitPanelUtil.Table>
          <HierarchyTable
            loading={props.loading}
            value={props.organisationHierarchy}
            onExpand={props.onExpand}
            columnResizeMode="expand"
            selectionMode="checkbox"
            onSelectionChange={e => {
              props.handleChange(e.value, 'node');
            }}
            selectionKeys={props.selectedNode}
            onSelect={e => {
              props.onSelect(e.node);
            }}
            onUnselect={e => {
              props.onUnselect(e.node);
            }}
            filterMode="strict"
            globalFilter={globalFilter}
            // lazy={true}
            header={getHeader()}
          >
            <Column
              style={{ fontWeight: 'bold' }}
              field="name"
              header={i18next.t('name')}
              expander={true}
            />
            <Column field="type" header={i18next.t('type')} />
          </HierarchyTable>
        </SplitPanelUtil.Table>
      </SplitPanelUtil>
    </div>
  );
};

export default consumeAPIs(NodeHierarchy);
